import { Button } from '@/components/ui/button'
import { Check } from 'lucide-react'

interface FormSubmitButtonProps {
  isSubmitting: boolean
  isDirty: boolean
}

export function FormSubmitButton({ isSubmitting, isDirty }: FormSubmitButtonProps) {
  return (
    <div className="flex justify-center pt-6">
      <Button
        type="submit"
        disabled={isSubmitting || !isDirty}
        className="bg-gray-800 hover:bg-gray-700 text-white px-6 py-2 flex items-center gap-2"
      >
        <Check className="w-4 h-4" />
        Concluído
      </Button>
    </div>
  )
}
